"use strict";

require("../../util/GlobalScript.js");

module.exports = {
  keys: {
    backspace: 8,
    enter: 13,
    esc: 27,
    left: 37,
    up: 38,
    right: 39,
    down: 40
  }
};